  <div class="clearfix mhl ptl">
    <h1 class="mvm mtn fgc1">Иконки</h1>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-chart">

        </span>
        <span class="mls"> icon-chart</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e900" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe900;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-man">

        </span>
        <span class="mls"> icon-man</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e901" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe901;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-finance">

        </span>
        <span class="mls"> icon-finance</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e902" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe902;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-calendar">

        </span>
        <span class="mls"> icon-calendar</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e903" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe903;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-delete">

        </span>
        <span class="mls"> icon-delete</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e904" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe904;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-rain">

        </span>
        <span class="mls"> icon-rain</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e905" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe905;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-realization">

        </span>
        <span class="mls"> icon-realization</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e906" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe906;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-edit">

        </span>
        <span class="mls"> icon-edit</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e907" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe907;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-exit">

        </span>
        <span class="mls"> icon-exit</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e908" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe908;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-grumble">

        </span>
        <span class="mls"> icon-grumble</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e909" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe909;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-brick">

        </span>
        <span class="mls"> icon-brick</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90a" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90a;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-list">

        </span>
        <span class="mls"> icon-list</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90b" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90b;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-location">

        </span>
        <span class="mls"> icon-location</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90c" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90c;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-logo-baiterek">

        </span>
        <span class="mls"> icon-logo-baiterek</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90d" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90d;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-save">

        </span>
        <span class="mls"> icon-save</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90e" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90e;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-building">

        </span>
        <span class="mls"> icon-building</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e90f" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe90f;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
    <div class="glyph fs1">
      <div class="clearfix bshadow0 pbs">
        <span class="icon-info">

        </span>
        <span class="mls"> icon-info</span>
      </div>
      <fieldset class="fs0 size1of1 clearfix hidden-false">
        <input type="text" readonly value="e910" class="unit size1of2" />
        <input type="text" maxlength="1" readonly value="&#xe910;" class="unitRight size1of2 talign-right" />
      </fieldset>
      <div class="fs0 bshadow0 clearfix hidden-true">
        <span class="unit pvs fgc1">liga: </span>
        <input type="text" readonly value="" class="liga unitRight" />
      </div>
    </div>
  </div>